import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { getGasCriterion } from 'redux/action/criterion';
import AuthRoute from '../session/AuthRoute';
import NotFound from '../error/NotFound';
import GasDetail from './gasDetail/GasDetail';
import GasCriterion from './gasCriterion/GasCriterion';
import GasGraph from './gasGraph/GasGraph';
import GasExcel from './excel/GasExcel';
import './Gas.css';

const Gas = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGasCriterion());
  }, []);

  return (
    <div className="gasContainer">
      <Switch>
        <AuthRoute exact path="/gas" render={(props) => <GasDetail {...props} />} />
        <AuthRoute path="/gas/detail" render={(props) => <GasDetail {...props} />} />
        <AuthRoute path="/gas/criterion" render={(props) => <GasCriterion {...props} />} />
        <AuthRoute path="/gas/graph" render={(props) => <GasGraph {...props} />} />
        <AuthRoute path="/gas/excel" render={(props) => <GasExcel {...props} />} />
        <Route render={NotFound} />
      </Switch>
    </div>
  );
};

export default Gas;
